import type { SVGProps } from "react";
export function Rewards(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={32}
      viewBox="0 0 32 32"
      width={32}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="m12.415 2.64876 2.4037 5.18125h4.6813c.2357-.00897.4684.05501.6665.1832.198.12819.3516.31435.4399.53308.0884.21873.107.45939.0535.68913s-.1765.43738-.3524.59459l-4.0575 3.99499 2.25 5.1675c.0994.2372.1217.4996.0636.7502-.058.2505-.1934.4764-.387.6457-.1937.1693-.4356.2733-.6917.2974-.256.024-.5131-.0331-.7349-.1633l-5.4313-3.0575-5.44371 3.0575c-.22162.1287-.47806.1846-.73314.1598-.25507-.0248-.49592-.1291-.68856-.2982-.19265-.169-.32736-.3942-.38514-.6439s-.03572-.5112.06309-.7477l2.25-5.165-4.055-3.99374c-.17591-.15643-.29934-.36328-.35346-.59238-.05412-.22909-.03632-.4693.05099-.68792.08731-.21861.23988-.405.43693-.53379.19705-.12878.42901-.1937.66429-.18591h4.67749l2.40122-5.185c.1062-.20125.2653-.36971.4601-.48722.1948-.1175.418-.17961.6456-.17961.2275 0 .4507.06211.6455.17961.1949.11751.3539.28597.4601.48722z" />
        <path d="m26.9375 20.375v4.375" />
        <path d="m24.75 22.5625h4.375" />
        <path d="m11 25.0625v5" />
        <path d="m8.5 27.5625h5" />
        <path d="m27.5625 1.9375v5" />
        <path d="m25.0625 4.4375h5" />
      </g>
    </svg>
  );
}
